import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";
import EnquiryForm from "../components/EnquiryForm";

export default function Home() {
  const controls = useAnimation();

  useEffect(() => {
    const sequence = async () => {
      await controls.start({ opacity: 0, y: 20 });
      await controls.start({
        opacity: 1,
        y: 0,
        transition: { duration: 0.8 },
      });
    };
    sequence();
  }, [controls]);

  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="bg-black text-white min-h-screen relative overflow-hidden">

        {/* Background animation */}
        <div className="absolute inset-0 z-0">
          <motion.div
            animate={{ scale: [1, 1.2, 1], rotate: [0, 360] }}
            transition={{ duration: 8, repeat: Infinity }}
            className="absolute top-20 left-10 w-32 h-32 bg-yellow-500 rounded-full opacity-20"
          />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

          {/* LEFT CONTENT */}
          <div>
            <motion.h1
              initial={{ opacity: 0, y: -50 }}
              animate={controls}
              className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 leading-tight text-white"
            >
              Strategic Consulting for Sustainable Growth
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="text-gray-300 max-w-xl mb-8 text-lg"
            >
              We help organizations navigate complexity, manage risk,
              and unlock long-term value through expert advisory services.
            </motion.p>
          </div>

          {/* RIGHT SIDE – INLINE FORM */}
          <div className="flex justify-center lg:justify-end">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </>
  );
}
